<template>
  <!--创建话题-->
  <div
    aria-labelledby="myModalLabe2"
    class="modal fade"
    id="applygroup"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <i class="iconfont icon-close"></i>
          </button>
          <h4 class="modal-title" id="myModalLabe2">申请入群</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <textarea
              class="form-control"
              placeholder="请填写入群原因"
              style="resize: vertical"
              rows="4"
              v-model="message"
              name="message"
              data-vv-as="入群原因 "
              v-validate="{ required: true, min: 1, max: 255 }"
            ></textarea>
            <span class="help-block" v-show="errors.has('message')">{{
              errors.first("message")
            }}</span>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" data-dismiss="modal" type="button">
            取消
          </button>
          <button class="btn btn-primary" type="button" @click="groupApply">
            提交
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { groupApply } from "@/api/group/group";
export default {
  name: "GroupApply",
  data() {
    return {
      message: "",
    };
  },
  props: {
    group_number: {
      type: String,
    },
  },
  methods: {
    groupApply() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          groupApply({
            group_number: this.group_number,
            message: this.message,
          })
            .then((res) => {
              if (res.status_code === 200) {
                $("#applygroup").modal("hide");
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.message = "";
                this.$nextTick(() => {
                  this.$validator.reset();
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        }
      });
    },
  },
};
</script>

<style scoped>
</style> 